export default __webpack_public_path__ + "e92cf92510af5c27a158c1ee83571e81.svg";